import { render } from "./Work.vue?vue&type=template&id=5a9dc920&scoped=true"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"

import "./Work.vue?vue&type=style&index=0&id=5a9dc920&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9dc920"]])

export default __exports__